module.exports = __webpack_public_path__ + "krecove-zily_4_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/obecna-a-zilni-chirurgie/krecove-zily_4_after.jpg
// module id = 1031
// module chunks = 0